import { createFileRoute } from '@tanstack/react-router';
import Tickets from 'src/pages/Organization/Event/Tickets';

export const Route = createFileRoute(
  '/$organizationSlug/events/$eventId/tickets',
)({
  component: Tickets,
});
